import Axios from 'axios'
import { API_LOGGER } from '@/service/index';
import _ from 'lodash';
import store from '@/store/index';
import { ADD_API_ERROR, SET_CP_DEVICE_INFO } from '@/store/constants/mutations';
import { GET_CP_DEVICE_INFO, GET_CP_DOMAIN, GET_CP_URL, GET_DEVICE_ID, GET_MS_ID, GET_HARMONY_ID, GET_USER } from '@/store/constants/getters';
import { CENTERAL_POINT_URL_DOMAIN } from '@/store/constants/actions';
import { ENDPOINTS } from './endpoints/index';

async function getTxtRecord() {
  try {
    const response = await fetch(`https://cloudflare-dns.com/dns-query?name=${process.env.VUE_APP_DNS_RECORD}&type=TXT`, {
      headers: { 'Accept': 'application/dns-json' }
    });
    const data = await response.json();
    const txtData = data.Answer[0].data;
    const unescaped = txtData.slice(1, -1).replace(/\\009/g, '\t').replace(/\\010/g, '\n');
    const lines = unescaped.split('\n');
    const result = {};
    for (const line of lines) {
      const colonIndex = line.indexOf(':');
      if (colonIndex === -1) continue;
      const key = line.slice(0, colonIndex).trim();
      const value = line.slice(colonIndex + 1).trim();
      result[key] = value;
    }
    return result;
  } catch {
    try {
      const { data } = await API.endpoints.dns.getCP()
      return data
    } catch {
      return null
    }
  }
}

const timeout = 1 * 60 * 1000
const axios_name = {
  cp_detect: 'centeralpoint-detect',
  relay: 'relay',
  relay_proxy: 'relay_proxy',
  meeting: 'meeting',
  error_capture: 'error-capture',
}
export const API = {
  Axios: {
    central_point: {
      v1: Axios.create({
        name: axios_name.cp_detect,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 1,
      }),
      v2: Axios.create({
        name: axios_name.cp_detect,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 2,
      }),
    },
    relay_proxy: {
      v1: Axios.create({
        name: axios_name.relay_proxy,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 1,
      }),
    },
    relay: {
      v1: Axios.create({
        name: axios_name.relay,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 1,
      }),
    },
    meeting: {
      v1: Axios.create({
        name: axios_name.meeting,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 1,
      }),
    },
    voip_error_capture: {
      v1: Axios.create({
        name: axios_name.error_capture,
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: timeout,
        version: 1,
      }),
    },
  },
  get errorMessages(){
    return {
      default: `There seems to be a issue try again later`,
      timeout: `It's taking longer than usual to connect to our servers. Please check your internet connection and try again.`,
      network: `Unable to establish a connection to our servers. Please ensure you're connected to the internet and try again.`,
      server_down: `Our servers are currently unavailable. We apologise for the inconvenience. Please try again later.`,
    }
  },
  init(){
    try {
      this.Axios.central_point.v1.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.central_point.v1.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
      
      
      this.Axios.central_point.v2.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.central_point.v2.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
      
      this.Axios.relay_proxy.v1.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.relay_proxy.v1.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
      
      this.Axios.relay.v1.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.relay.v1.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
      
      this.Axios.meeting.v1.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.meeting.v1.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
      
      this.Axios.voip_error_capture.v1.interceptors.request.use(this.onRequest.bind(this))
      this.Axios.voip_error_capture.v1.interceptors.response.use(this.onSuccess.bind(this),this.onError.bind(this))
    } catch (error) {
      console.log('API',error)
    } finally {
      if(process.env.NODE_ENV !== 'production'){
        window.voip_app.API = this
      }
      // eslint-disable-next-line no-unsafe-finally
      return this
    }
  },
  async onRequest(config){
    API_LOGGER.info(config.url,config)
    const meeting_id = config?.extra_data?.meeting_id
    const api_name = config.name
    const url = config?.url
    const method = config?.method?.toLowerCase?.() ?? ''
    const attaching_device_id = config?.extra_data?.attaching?.device_id
    const attaching_ms_harmony = config?.extra_data?.attaching?.ms_harmony
    const attaching_fp_data = config?.extra_data?.attaching?.fp_data
    const attaching_ip_address = config?.extra_data?.attaching?.ip_address
    const device_info = config?.extra_data?.device_info
    try {
      if (api_name==axios_name.relay_proxy){
        const cp_url = store.getters[GET_CP_URL]
        if(!cp_url){
          const defultDomainData = await getTxtRecord()
          let ddata;
          if(!store.getters[GET_CP_DOMAIN] || store.getters[GET_CP_DOMAIN]==defultDomainData?.domain) {
            ddata=defultDomainData
          } else {
            const { data } = await API.endpoints.dns.getCP({
              domain: store.getters[GET_CP_DOMAIN]
            })
            ddata = data
          }
          store.dispatch(CENTERAL_POINT_URL_DOMAIN,{
            centeralpoint: ddata?.base_url || ddata?.centeralpoint || '',
            domain: ddata?.domain || '',
          })
        }
        if(!store.getters[GET_CP_DEVICE_INFO]?.ip && !device_info){
          await API.endpoints.dns.deviceInfo()
        }
      }
    } finally {
      if(api_name==axios_name.cp_detect){
        let url = process.env.VUE_APP_CENTRAL_POINT_DETECT
        if(config.version==1) url += `v1/`
        else url += `v2/`
        config.baseURL = url;
      } else if(api_name==axios_name.meeting){
        const res = await this.endpoints.auth.meetingServer(meeting_id ?? '')
        config.baseURL = res?.data?.harmony ? `${res?.data?.harmony}/api/v1/` : ''
        config.jitsi_url = res?.data?.jitsi_url ? `${res?.data?.jitsi_url}http-bind` : ''
      } else if(api_name==axios_name.relay_proxy){
        const cp_url = store.getters[GET_CP_URL]
        config.baseURL=`${cp_url}api/v1/`
        if(attaching_device_id) {
          const device_id = store.getters[GET_DEVICE_ID]
          if(method=='get'){
            if(url.includes(':device_id')) {
              config.url = url.replace(':device_id',device_id)
            } else {
              _.set(config,'params.device_id',device_id)
            }
          }
          else {
            _.set(config,'data.device_id',device_id)
          }
        }
        if(attaching_ip_address) {
          const fp_data = store.getters[GET_CP_DEVICE_INFO]
          if(method=='get'){
            if(url.includes(':ip')) {
              config.url = url.replace(':ip',fp_data.ip)
            } else {
              _.set(config,'params.ip',fp_data.ip)
            }
          }
          else {
            _.set(config,'data.ip',fp_data.ip)
          }
        }
        if(attaching_fp_data) {
          const fp_data = store.getters[GET_CP_DEVICE_INFO]
          if(method=='get'){
            _.set(config,'params.fp_data',fp_data)
          }
          else {
            _.set(config,'data.fp_data',fp_data)
          }
        }
        if(attaching_ms_harmony) {
          const mothership_id = store.getters[GET_MS_ID]
          const harmony_id = store.getters[GET_HARMONY_ID]
          if(method=='get'){
            _.set(config,'params.ms_server',mothership_id)
            _.set(config,'params.server_template',harmony_id)
          }
          else {
            _.set(config,'data.ms_server',mothership_id)
            _.set(config,'data.server_template',harmony_id)
          }
        }
      } else if(api_name==axios_name.relay){
        const { data } = await API.endpoints.auth.signupServer()
        config.baseURL=data?.server ? `${data.server}/api/v1/` : ''
      } else if(api_name==axios_name.error_capture) {
        let url = process.env.VUE_APP_GET_ERROR_CAPTURE_API
        if(config.version==1) url += `/api/v1/`
        config.baseURL = url;
      }
      // eslint-disable-next-line no-unsafe-finally
      return config;
    }
  },
  async onError(ex){
    API_LOGGER.danger(ex?.config?.url,{ex})
    const api_name = ex?.config?.name
    let default_message = ex?.config?.extra_data?.default_message || this.errorMessages.default
    let message = ex?.config?.extra_data?.error_message || ''
    let response_error = ex?.response?.data ?? {}
    let errors = {}
    let api_error = false
    const status_code = ex?.response?.status
    errors = response_error?.errors ?? {}
    const response_description = response_error?.description
    const response_message = response_error?.message
    const user = store.getters[GET_USER]
    const cp_domain = store.getters[GET_CP_DOMAIN]
    if(errors instanceof Object){
      Object.keys(errors).forEach((key)=>{
        errors[key] = typeof errors[key] == 'string' ? [errors[key]] : errors[key]
      })
      response_error.errors=errors
    }
    if(!message) {
      if(ex.message == "Network Error"){
        if(!window?.navigator?.onLine){
          message = this.errorMessages.network
        } else {
          message = this.errorMessages.server_down
        }
      } else if(ex.message.includes('timeout')){
        message = this.errorMessages.timeout
      } else if(status_code==500){
        api_error=true
        message = default_message
      } else {
        api_error=true
        message = response_description || response_message || ex.message || default_message
      }
    }
    if(![axios_name.error_capture].includes(api_name)) {
      if(ex?.response?.status>=500 && ex?.response?.status!=502) {
        const url = new URL(ex?.config?.baseURL)
        store.commit(ADD_API_ERROR,{
          domain: url.host,
          method: ex?.config?.method,
          status: `${ex?.response?.status}`,
          url: ex?.config?.url,
          accountcode: user?.voipaccount ?? null,
          app: 'dialer-login',
          cp_domain: cp_domain,
        })
      }
    }
    const response = {
      own_errors: errors,
      own_message: message,
      api_error: api_error,
      response_error: response_error,
      ...ex,
      message: ex.message,
      stack: ex.stack,
      cancel: Axios.isCancel?.(ex),
    }
    throw response
  },
  async onSuccess(response){
    API_LOGGER.success(response?.config?.url,response)
    const api_name = response?.config?.name
    const device_info = response?.config?.extra_data?.device_info
    if (api_name==axios_name.meeting) {
      const jitsi_url = response.config.jitsi_url
      API_LOGGER.log(jitsi_url)
      return {
        ...response,
        data: {
          ...response.data,
          jitsi_url
        }
      }
    } else if (device_info && api_name==axios_name.relay_proxy) {
      store.commit(SET_CP_DEVICE_INFO,response.data)
    } else {
      return response
    } 
  },
  endpoints: ENDPOINTS,
}
